import Button from '../Button';
import { MoreActions } from '../MoreActions';
import type { ActionType } from '../MoreActions';

type ButtonsProps = {
  buttons: Array<ActionType | Falsy>;
  visibleCount?: number;
};

const Buttons: React.FC<ButtonsProps> = ({ buttons, visibleCount = 3 }) => {
  const moreButtons = [...buttons].filter(b => typeof b === 'object' && !!b);
  const visibleButtons = moreButtons.splice(0, visibleCount).filter(Boolean);

  return (
    <div className="flex flex-row items-center gap-md">
      {visibleButtons.map((button, index) => (
        <Button key={index} {...button} label={undefined} />
      ))}
      {!!moreButtons.length && <MoreActions buttons={moreButtons} />}
    </div>
  );
};

export default Buttons;
